// actions
import { COMMON_SLICE_NAME } from '../actions/common.action';

// models
import type { CommonState } from '../models/common.model';

// libraries
import { createSlice } from '@reduxjs/toolkit';

const initialState: CommonState = {
  menuList: [],
  currentMenu: null,
  credentialCard: {
    iqama: {
      number: '',
      expiryDate: null
    },
    passport: {
      number: '',
      expiryDate: null
    },
    gatepass: {
      number: '',
      expiryDate: null
    }
  },

  // category
  category: [],
  categoryOption: [],

  // designation
  designation: [],
  designationOption: [],

  // discipline
  discipline: [],
  disciplineOption: [],

  // occupation
  occupation: [],
  occupationOption: [],

  // zone
  zone: [],
  zoneOption: [],

  // companyType
  companyType: [],
  companyTypeOption: []
};

const commonSlice = createSlice({
  name: COMMON_SLICE_NAME,
  initialState,
  reducers: {
    setMenuList: (state, action) => {
      state.menuList = action.payload;
    },
    setCurrentMenu: (state, action) => {
      state.currentMenu = action.payload;
    },
    setCredentialCard: (state, action) => {
      state.credentialCard = action.payload;
    },
    resetCredentialCard: (state) => {
      state.credentialCard = initialState.credentialCard;
    },
    setCategory: (state, action) => {
      const { list, option } = action.payload;

      state.category = list;
      state.categoryOption = option;
    },
    setDesignation: (state, action) => {
      const { list, option } = action.payload;

      state.designation = list;
      state.designationOption = option;
    },
    setDiscipline: (state, action) => {
      const { list, option } = action.payload;

      state.discipline = list;
      state.disciplineOption = option;
    },
    setOccupation: (state, action) => {
      const { list, option } = action.payload;

      state.occupation = list;
      state.occupationOption = option;
    },
    setZone: (state, action) => {
      const { list, option } = action.payload;

      state.zone = list;
      state.zoneOption = option;
    },
    setCompanyType: (state, action) => {
      const { list, option } = action.payload;

      state.companyType = list;
      state.companyTypeOption = option;
    }
  }
});

export const common = commonSlice.name;
export const commonReducer = commonSlice.reducer;
export const commonActions = commonSlice.actions;
export default commonSlice.reducer;
